// Round-trip entre las imágenes de un presupuesto y el `fileList` del <Upload>
// de antd. Las imágenes se suben primero a `upload/file/presupuesto` (tabla
// `files`); el presupuesto solo guarda los ids en `images` al crear/editar.

export const MAX_BUDGET_IMAGES = 10;

/**
 * Ids de `files` a enviar en el payload. Solo cuenta los archivos que ya
 * terminaron de subir: los que siguen subiendo o fallaron se descartan.
 */
export const fileListToImageIds = (fileList) => {
  if (!Array.isArray(fileList)) return [];
  const ids = fileList
    .filter((f) => f?.status === 'done')
    .map((f) => f.fileId ?? f.response?.file?.id)
    .map(Number)
    .filter((id) => Number.isInteger(id) && id > 0);
  return Array.from(new Set(ids));
};

/**
 * Filas de `GET /get-images-budget/:id` → `fileList` precargado del <Upload>.
 * Descarta las filas legacy sin `fileId` (imágenes previas a S3): no se pueden
 * re-enviar como id de `files`.
 */
export const budgetImagesToFileList = (images, getDownloadUrl) => {
  if (!Array.isArray(images)) return [];
  return images
    .filter((img) => Number.isInteger(Number(img?.fileId)) && Number(img.fileId) > 0)
    .map((img) => {
      const fileId = Number(img.fileId);
      const url = getDownloadUrl(fileId);
      return {
        uid: `budget-image-${img.id ?? fileId}`,
        name:
          String(img.image || '')
            .split('/')
            .pop() || `imagen-${fileId}`,
        status: 'done',
        fileId,
        url,
        thumbUrl: url,
      };
    });
};

/**
 * Cantidad de imágenes legacy (sin `fileId`, previas a S3). El formulario no
 * puede mostrarlas; el backend las conserva siempre al editar.
 */
export const countLegacyImages = (images) =>
  Array.isArray(images)
    ? images.filter((img) => !(Number.isInteger(Number(img?.fileId)) && Number(img.fileId) > 0))
        .length
    : 0;
